import CountryPageTemplate from "../../components/country/CountryPageTemplate";
import { countryPages } from "../../data/countries";

function AustraliaPage() {
  return <CountryPageTemplate country={countryPages.australia} />;
}

export default AustraliaPage;
